import {
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_COLUMNS,
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMNS,
} from 'pages/FundInvestments/common/constants';
import { TooltipCell } from 'pages/FundInvestments/components';
import { getWeightedExpression } from 'pages/FundInvestments/hooks/useFundInvestmentMarketAdjustmentSheet/config/createParser/utils/getWeightedExpression';
import { normalizeHiddenCell } from 'pages/FundInvestments/hooks/useFundInvestmentMarketAdjustmentSheet/config/createParser/utils/normalizeHiddenCell';
import { normalizePercentageCell } from 'pages/FundInvestments/hooks/useFundInvestmentMarketAdjustmentSheet/config/createParser/utils/normalizePercentageCell';
import { HandleWeightedCellsParams } from './handleWeightedCells.types';

const { metric_selection_as_of_market_date: METRIC_SELECTION_AS_OF_MARKET_DATE, percentage_change: PERCENTAGE_CHANGE } =
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMNS;

const { weighted: WEIGHTED } = FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_COLUMNS;

const handleWeightedCells = (params: HandleWeightedCellsParams): void => {
  const { allComparisonsExpression, allWeightingExpression, cell, colNumber } = params;

  switch (colNumber) {
    case METRIC_SELECTION_AS_OF_MARKET_DATE.column:
      Object.assign(cell, {
        className: `${cell.className} left-aligned read-only--white`,
        component: <TooltipCell title={WEIGHTED.title} tooltipContent={WEIGHTED.tooltip} />,
        forceComponent: true,
        hidden: false,
        value: WEIGHTED.title,
      });
      break;

    case PERCENTAGE_CHANGE.column:
      normalizePercentageCell(cell);

      Object.assign(cell, {
        customKey: WEIGHTED.key,
        expr: `=${getWeightedExpression({
          allComparisonsExpression,
          allWeightingExpression,
          isSingleComparison: false
        })}`,
      });
      break;

    default:
      normalizeHiddenCell(cell);
      break;
  }
};

export default handleWeightedCells;
